module.exports = __webpack_public_path__ + "img/cable-ic-green.ba0ff253.svg";